// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"f88f06f3","89":"f7f6248c","97":"3ceb5642","158":"b04ca2c2","227":"9a29e0c5","467":"7a6187ab","758":"d476f9ed","873":"e8f3a2e9","894":"3dc51cb1"}[chunkId] + ".chunk.css";
};